module.exports = "/_next/static/images/about-the-product-kit-velieve@2x-min-9d8a9a5de2796d403c4d38d1cd3acee0.png.webp";